import http from "./http";

function get_route_list(data) {
  return http.post(`Vtsroutes_List`, data);
}

function deleteRoute(data) {
  return http.post(`routesDelete`, data);
}

function add_route(data) {
  return http.post(`save_Vtsroutes`, data);
}

function get_city_name(data) {
  return http.post(`getLatLong`, data);
}

function update_route(data) {
  return http.post(`Updateroutes`, data);
}

function fetch_via_route_data(data) {
  return http.post(`Vtsroutes_Via_List`, data);
}

function delete_via_route_list(data) {
  return http.post(`routes_ViaDelete`, data);
}

function update_via_route_data(data) {
  return http.post(`Update_Via`, data);
}

function add_via_route_data(data) {
  return http.post(`save_Via`, data);
}

function fullRouteList(data) {
  return http.post(`RoutesViaList`, data);
}

function updateRouteandVia(data) {
  return http.post(`updateViaRoutes`, data);
}

const RouteService = {
  get_route_list,
  deleteRoute,
  add_route,
  get_city_name,
  update_route,
  fetch_via_route_data,
  delete_via_route_list,
  update_via_route_data,
  add_via_route_data,
  fullRouteList,
  updateRouteandVia,
};

export default RouteService;
